import React from 'react';
import Features from '../components/Features';

const Clotures = () => {
  return <Features />;
};

export default Clotures;